import React from "react";
import FondoClientes from "../images/Fondos/FondoClientes.jpg";
// LogosClientes
import logoAcacoop from "../images/Logos/AcacoopBlanco.png";
import MolinosAgro from "../images/Logos/MolinosAgroBlanco.png";
import logoCargill from "../images/Logos/CargillBlanco.png";
import LAC from "../images/Logos/LACblanco.png";
import LMI from "../images/Logos/LMI.png";
import LDC from "../images/Logos/LDC.svg";
import DDS from "../images/Logos/DESDEEL.png";
import PEMAN from "../images/Logos/PEMAN1.webp";
import TecnoCampo from "../images/Logos/TecnoCampoBlanco.png";
import Cresud from "../images/Logos/CresudBlanco.png";
import Lartirigoyen from "../images/Logos/LartirigoyenBlanco.png";
import Roagro from "../images/Logos/RoagroBlanco.png";
import CIGRA from "../images/Logos/CigraBlanco.png";
import Pronor from "../images/Logos/PronorBlanco.png";
import Prodema from "../images/Logos/prodemanblanco.png";
import Miru from "../images/Logos/MIRU.png";
import Cofco from "../images/Logos/Cofco.png";
import Bunge from "../images/Logos/BungeBlanco.png";
import logoAlea from "../images/Logos/alea.png";
import logoAGD from "../images/Logos/AGD.png";
import Adecoagro from "../images/Logos/Adecoagro.png";
import Minetti from "../images/Logos/MinettiBlanco.png";

// LogosProveedores SorbonaBerria.svg
import SorbonaBerria from "../images/Logos/SorbonaBerria.svg";
import ATALAYA from "../images/Logos/ATA.png";
import logoCappri from "../images/Logos/logoCappri.png";
import logoAvanzar from "../images/Logos/AvanzarBlanco.png";

const ClientesSection = () => {
  return (
    <section
      id="clientes"
      className="relative w-full py-12 md:py-24 lg:py-32 text-white overflow-hidden"
    >
      {/* Fondo con imagen y gradiente */}
      <div className="absolute inset-0 z-0">
        <img
          src={FondoClientes}
          alt="Fondo Camion en la niebla"
          className="object-cover w-full h-full"
        />
        <div
          className="absolute inset-0"
          style={{
            background: `
              linear-gradient(90deg, rgba(20, 24, 54, 0.95) 0%, rgba(20, 24, 54, 0.2) 47%, rgba(20, 24, 54, 0) 49.8%, rgba(20, 24, 54, 0) 50.2%, rgba(20, 24, 54, 0.2) 53%, rgba(20, 24, 54, 0.95) 100%),
              linear-gradient(180deg, rgba(20, 24, 54, 0.95) 0%, rgba(20, 24, 54, 0.2) 20%, rgba(20, 24, 54, 0) 35%, rgba(20, 24, 54, 0) 65%, rgba(20, 24, 54, 0.2) 80%, rgba(20, 24, 54, 0.95) 100%)
            `,
          }}
        />
      </div>

      {/* Contenido */}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {/* Sección de Clientes */}
        <div className="mb-32">
          <h2 className="text-2xl font-bold mb-16 text-center">
            NUESTROS CLIENTES:
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-items-center">
            <img
              src={logoAcacoop}
              alt="Logo Acacoop"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Adecoagro}
              alt="Logo Adecoagro"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={MolinosAgro}
              alt="Logo MolinosAgro"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={logoCargill}
              alt="Logo Cargill"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={LAC}
              alt="LAC"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={LMI}
              alt="LMI"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={LDC}
              alt="LDC"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={DDS}
              alt="DDS"
              className="w-full h-auto max-h-24 object-contain p-2 rounded"
            />
            <img
              src={PEMAN}
              alt="PEMAN"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={TecnoCampo}
              alt="TecnoCampo"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Cresud}
              alt="Cresud"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Minetti}
              alt="Minetti"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Lartirigoyen}
              alt="Lartirigoyen"
              className="w-full h-auto max-h-14 object-contain p-2 rounded"
            />
            <img
              src={Roagro}
              alt="Roagro"
              className="w-full h-auto max-h-20 object-contain p-2 rounded"
            />
                        <img
              src={Pronor}
              alt="Pronor"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={CIGRA}
              alt="CIGRA"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Prodema}
              alt="Prodema"
              className="w-full h-auto max-h-14 object-contain p-2 rounded"
            />
            <img
              src={Miru}
              alt="Miru"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={Cofco}
              alt="Cofco"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
                                    <img
              src={Bunge}
              alt="Bunge"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={logoAlea}
              alt="Alea"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={logoAGD}
              alt="AGD"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
          </div>
        </div>

        {/* Sección de Proveedores */}
        <div>
          <h2 className="text-2xl font-bold mb-16 text-center">
            PROVEEDORES DE COMBUSTIBLE:
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-items-center">
            <img
              src={LAC}
              alt="LAC"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={SorbonaBerria}
              alt="SorbonaBerria"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={ATALAYA}
              alt="ATALAYA"
              className="w-full h-auto max-h-24 object-contain p-2 rounded"
            />
            <img
              src={logoCappri}
              alt="logoCappri"
              className="w-full h-auto max-h-16 object-contain p-2 rounded"
            />
            <img
              src={logoAvanzar}
              alt="logoAvanzar"
              className="w-full h-auto max-h-14 object-contain p-2 rounded"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientesSection;
